import api from '../../api/index.js'

const state = {

}

const getters = {
}

const actions = {
    GetCommandAdList({commit}, payload) { 
        return new Promise((resolve, reject) => {
            api.get('/CommandAd/GetCommandAdList',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            })
        })
    },
}

const mutations = {
}

export default {
    state,
    getters,
    actions,
    mutations
}
